import FJTrack, { TrackNode, FixNode } from './track/FJTrack';
import FJUtil from '../util/FJUtil';
import FJCoreConfig from './FJCoreConfig';
import FJViewConstant from '../constants/FJViewConstant';
import $ from 'jquery';
import { isUndefined } from 'lodash-es';
import FJDomCanvasRender from './export/FJDomCanvasRender';
import FJMathUtil from '../util/FJMathUtil';
import FJArchiveUtil from '../util/FJArchiveUtil';
import FJImageUtil from '../util/FJImageUtil';
import FJMotionUtil from '../util/FJMotionUtil';
import { LineTrackNode } from './track/FJLineTrack';
import FJComponentUtil from '../util/FJComponentUtil';
import FJCssPerspectiveToWebGLManager from '../store/FJCssPerspectiveToWebGL/FJCssPerspectiveToWebGLManager';
import FJPoolStore from '../store/FJPoolStore';
class FJSprite {
    constructor(props) {
        props = props || {};
        this._groupParent = null; // 打组对象
        this._placeholderView = null;
        this._beforeView = null;
        this._relativeRect = (props && props.relativeRect) || null;
        this._type = (props && props.type) || 'sprite';
        this._id = (props && props.id) || FJArchiveUtil.createId(true);
        this._opacity = typeof props.opacity !== 'undefined' ? props.opacity : 1;
        this._owner = (props && props.owner) || null;
        this._angle = typeof props.angle !== 'undefined' ? props.angle : 0;
        this._track = new FJTrack({
            owner: this,
            hasRotationNode: typeof props.hasRotationNode !== 'undefined' ? props.hasRotationNode : false,
            hasNode: props && props.hasTrackNode,
            trackNodeBoxShadow: FJCoreConfig.trackNodeBoxShadow,
            keepAspectRatio: typeof props.keepAspectRatio !== 'undefined' ? props.keepAspectRatio : true,
            keepAspectVertical: typeof props.keepAspectVertical !== 'undefined' ? props.keepAspectVertical : false,
            keepAspectHorizontal:
                typeof props.keepAspectHorizontal !== 'undefined' ? props.keepAspectHorizontal : false,
        });
        this._hitTestCanvas = null; // 用于点击的时候做透明度检测的canvas
        this._alphaCanvas = document.createElement('canvas');

        this._flipX = typeof props.flipX !== 'undefined' ? props.flipX : 1;
        this._flipY = typeof props.flipY !== 'undefined' ? props.flipY : 1;
        this._selected = false;
        this._isGroup = false; // 是否是多选状态
        this._isExport = false;
        // 是否是替换的状态
        this._isReplace = false;
        // 正在解码
        this._isDecoding = false;
        this._exportView = null;
        this._isLock = typeof props.isLock !== 'undefined' ? props.isLock : false;

        /**
         * 是否作用 WebGLEffect
         * @type {boolean}
         * @private
         */
        this._applyToWebGLEffect =
            props && typeof props.applyToWebGLEffect === 'boolean' ? props.applyToWebGLEffect : false;
    }

    static updateResizeCursor(trackNode) {
        let cursorType;
        switch (trackNode) {
            case TrackNode.MOVE:
                cursorType = 'move';
                break;
            case TrackNode.LEFT_TOP:
            case TrackNode.RIGHT_BOTTOM:
                cursorType = FJCoreConfig.default_se_resize;
                break;
            case TrackNode.RIGHT_TOP:
            case TrackNode.LEFT_BOTTOM:
                cursorType = FJCoreConfig.default_nw_resize;
                break;
            case TrackNode.TOP:
            case TrackNode.BOTTOM:
                cursorType = FJCoreConfig.default_vertical_resize;
                break;
            case TrackNode.LEFT:
            case TrackNode.RIGHT:
                cursorType = FJCoreConfig.default_horizontal_resize;
                break;
            case TrackNode.ROTATE:
                cursorType = 'rotate';
                break;
            case LineTrackNode.START_POINT:
            case LineTrackNode.END_POINT:
            case LineTrackNode.CONTROL_POINT:
                cursorType = 'crosshair';
                break;
            default:
                cursorType = 'auto';
        }
        FJUtil.updateCursor(cursorType);
    }

    get isDecoding() {
        return this._isDecoding;
    }

    get track() {
        return this._track;
    }

    set isLock(value) {
        this._isLock = value;
    }

    get isLock() {
        return this._isLock;
    }

    /**
     * @description 转换为JSON数据
     */
    toJSON() {
        return {
            name: this._name,
            opacity: this._opacity,
            relativeRect: JSON.parse(JSON.stringify(this._relativeRect)),
            id: this._id,
            angle: this._angle,
            flipX: this._flipX,
            flipY: this._flipY,
            type: this._type,
            isLock: this._isLock,
        };
    }

    /**
     * @description 由JSON数据还原对象数据
     * @param data
     */
    fromJSON(data) {
        this._name = data.name;
        this._relativeRect = JSON.parse(JSON.stringify(data.relativeRect));
        this._id = data.id;
        this._angle = data.angle;
        this._flipX = data.flipX;
        this._flipY = data.flipY;
        this._type = data.type;
        this._opacity = typeof data.opacity !== 'undefined' ? data.opacity : 1;
        this._isLock = typeof data.opacity !== 'undefined' ? data.isLock : false;
    }

    // 更新当前对象视图渲染
    renderCache() {
        this.updateNode();
        this.updateStyle();
    }

    // 更新视图
    updateView() {}

    // 更新视图节点
    updateNode() {}

    // 更新视图样式
    updateStyle() {
        this._updateRotationView();
        this._updateOpacityView();
        this._updateFlipView();
        this._updateRotationView();
    }

    clear() {}

    encode() {
        return {
            name: this._name,
            opacity: this._opacity,
            relativeRect: JSON.parse(JSON.stringify(this._relativeRect)),
            id: this._id,
            angle: this._angle,
            flipX: this._flipX,
            flipY: this._flipY,
            isLock: this._isLock,
        };
    }

    decode(data) {
        this._isDecoding = true;
        this._name = data.name;
        this._opacity = typeof data.opacity !== 'undefined' ? data.opacity : 1;
        if (this._opacity === 100) this._opacity = 1;
        this._relativeRect = data.relativeRect;
        this._id = data.id;
        this.angle(data.angle);
        this._flipX = typeof data.flipX !== 'undefined' ? data.flipX : 1;
        this._flipY = typeof data.flipY !== 'undefined' ? data.flipY : 1;
        this._isLock = data.isLock || false;
        this._isDecoding = false;
        this.renderCache();
    }

    async decodeRely() {}

    clone(object) {
        if (typeof object === 'undefined') object = new FJSprite();
        object.setName(this._name);
        object.relativeRect(this._relativeRect);
        object.angle(this._angle);
        object.opacity(this._opacity);
        object.flipX(this._flipX);
        object.flipY(this._flipY);
        object.isLock = this._isLock;

        return object;
    }

    /**
     * @desc 刷新保存时的数据
     */
    updateProjectData() {
        if (!this._owner || this._isDecoding) return;
        this._owner.saveElement();
    }

    /**
     * @desc 用于渲染的对象
     * @return {*}
     */
    element() {
        return null;
    }

    setGroupParent(value) {
        this._groupParent = value;
    }

    groupParent() {
        return this._groupParent;
    }

    relativeRect(rect) {
        if (typeof rect === 'undefined') {
            return this.getRelativeRect();
        } else {
            this.setRelativeRect(rect);
        }
    }

    /**
     * @description 获取对象的相对尺寸
     * @return {null|*}
     */
    getRelativeRect() {
        return this._relativeRect ? { ...this._relativeRect } : null;
    }

    opacity() {
        if (typeof arguments[0] == 'undefined') {
            return this._opacity;
        } else {
            this._opacity = arguments[0];
            this.renderCache();
        }
    }

    flipX() {
        if (typeof arguments[0] === 'undefined') {
            return this._flipX;
        } else {
            this._flipX = arguments[0];
            this.renderCache();
        }
    }

    flipY() {
        if (typeof arguments[0] === 'undefined') {
            return this._flipY;
        } else {
            this._flipY = arguments[0];
            this.renderCache();
        }
    }

    _updateOpacityView() {
        let view = this.element();
        if (view) {
            view.style.opacity = this._opacity;
        }
    }

    _updateFlipView() {
        let view = this.element();
        if (view) {
            if (view.style.transform) {
                let styles = view.style.transform.replace(/, /g, ',').split(' ');
                let newStyle = [];
                styles.forEach(s => {
                    if (s.indexOf('scale') === -1 && s.indexOf('rotate') === -1) newStyle.push(s);
                });
                newStyle.push('scale(' + this._flipX + ',' + this._flipY + ')');
                newStyle.push('rotate(' + this._angle * this._flipX * this._flipY + 'deg)');
                view.style.transform = newStyle.join(' ');
            } else {
                view.style.transform = 'scale(' + this._flipX + ',' + this._flipY + ')';
            }
        }
    }

    _updateRotationView() {
        let view = this.element();
        if (view) {
            if (view.style.transform) {
                let styles = view.style.transform.split(' ');
                let newStyle = [];
                styles.forEach(s => {
                    if (s.indexOf('rotate') === -1) newStyle.push(s);
                });
                newStyle.push('rotate(' + this._angle * this._flipX * this._flipY + 'deg)');
                view.style.transform = newStyle.join(' ');
            } else {
                view.style.transform = 'rotate(' + this._angle * this._flipX * this._flipY + 'deg)';
            }
        }
    }

    angle(value) {
        if (isUndefined(value)) {
            return this._angle;
        } else {
            this._angle = value;
            if (!this.isDecoding) {
                this.renderCache();
            }
        }
    }

    setName(name) {
        this._name = name;
    }

    getName() {
        return this._name;
    }

    getParentElement() {
        if (this._groupParent) {
            return this._groupParent.layer();
        } else {
            let element = this.element();
            if (!element) return null;
            return element.parentNode;
        }
    }

    getParentElementSize() {
        if (this._groupParent) {
            let previewViewSize = FJArchiveUtil.getCurrentPreviewBoardViewSize();
            return this._groupParent.getRect({
                width: previewViewSize.width,
                height: previewViewSize.height,
            });
        } else {
            let parentElement = this.getParentElement();
            if (!parentElement) return { width: 0, height: 0 };

            let w = parentElement.offsetWidth,
                h = parentElement.offsetHeight;
            if (w !== 0 && h !== 0) return { width: w, height: h };
            else return { width: 0, height: 0 };
        }
    }

    setIsReplace(value) {
        if (this._isReplace !== value) {
            this._isReplace = value;
        }
    }

    /**
     * @desc 将对象的元素添加到视图中
     * @param view
     */
    addToView(view, viewSize) {
        if (!view) return;
        this._beforeView = null;
        let element = this.element();
        if (element) {
            if (element.parentNode !== view) {
                view.appendChild(element);
                this.updateView(viewSize || { width: view.offsetWidth, height: view.offsetHeight }, false);
            }
        } else {
            this._placeholderView = view;
        }
    }

    /**
     * @desc 插入到view中，并在beforeView之前
     * @param view - 要插入到的图层
     * @param beforeView - 插入到beforeView之前
     */
    insertToView(view, beforeView) {
        if (!view) return;

        let element = this.element();
        if (element) {
            if (view !== element.parentNode) {
                if (beforeView) view.insertBefore(element, beforeView);
                else view.appendChild(element);
                let viewSize = FJComponentUtil.getElementViewSize(view);
                this.updateView(viewSize, false);
                this._placeholderView = null;
                this._beforeView = null;
            }
        } else {
            this._placeholderView = view;
            this._beforeView = beforeView;
        }
    }

    getViewSize() {
        return null;
    }

    /**
     * @desc 点击时是否进行透明度检测
     * @return {boolean}
     */
    _hitWithAlpha() {
        return false;
    }

    /**
     * @desc 从视图中删除当前元素
     * @param shouldStaySelection
     */
    removeFromView(shouldStaySelection) {
        if (!shouldStaySelection) {
            this.deselect();
        }
        let element = this.element();
        if (element && element.parentNode) {
            element.parentNode.removeChild(element);
        }
        this._beforeView = null;
        this._placeholderView = null;
    }

    changeLayerFromIndexToIndex(fromIndex, toIndex) {
        let element = this.element();
        if (element && element.parentNode) {
            let parent = element.parentNode;
            let count = Math.abs(fromIndex - toIndex); // 需要查找遍历的次数
            let insertBeforeLayer = toIndex > fromIndex ? element.nextSibling : element; // 当前的元素，要插入在insertBeforeLayer图层之下，通过循环遍历去查找
            while (count !== 0 && insertBeforeLayer) {
                if (toIndex > fromIndex) insertBeforeLayer = insertBeforeLayer.nextSibling;
                else insertBeforeLayer = insertBeforeLayer.previousSibling;
                count--;
            }

            parent.removeChild(element);
            if (insertBeforeLayer) parent.insertBefore(element, insertBeforeLayer);
            else parent.appendChild(element);
        }
    }

    /**
     * @description 设置对象的相对尺寸
     * @param rect
     */
    setRelativeRect(rect) {
        if (JSON.stringify(rect) === JSON.stringify(this._relativeRect)) return;

        this._relativeRect = { ...rect };
    }

    /**
     * @description 由布局更新relativeRect
     * @param viewRect
     */
    updateRelativeRect(viewRect) {
        let eleRect = this.getElementRenderRect();
        if (viewRect.width === 0) {
            return;
        }
        this.setRelativeRect({
            x: (eleRect.left - viewRect.left) / viewRect.width,
            y: (eleRect.top - viewRect.top) / viewRect.height,
            width: eleRect.width / viewRect.width,
            height: eleRect.height / viewRect.height,
        });
    }

    /**
     * @desc 获取对象的大小
     */
    getElementRenderRect() {
        if (this.element() && this.getParentElement() && this._relativeRect) {
            let size = this.getParentElementSize();
            if (size.width === 0 || size.height === 0) return null;
            return this.getRect(size);
        } else return null;
    }

    clearRelativeRect() {
        this._relativeRect = null;
    }

    _convertRectToRelativeRect({ width, height }, rect) {
        this.setRelativeRect({
            x: rect.x / width,
            y: rect.y / height,
            width: rect.width / width,
            height: rect.height / height,
        });
        return this._relativeRect;
    }

    /**
     * @description 获取实际的尺寸信息
     * @param viewSize 容器尺寸
     */
    getRect(viewSize, useCurrentViewSize = false) {
        if (!this._relativeRect) return null;
        if (!viewSize) return null;

        let { x, y, width, height } = this._relativeRect;
        if (this?.isCropMode && this.groupParent && this?.isCropMode() && this.groupParent()) {
            let elementViewSize = FJArchiveUtil.getCurrentPreviewBoardViewSize();
            if (elementViewSize.width !== 0 && elementViewSize.height !== 0 && !useCurrentViewSize) {
                viewSize = elementViewSize;
            }
            let parentRect = this.groupParent().getRelativeRect();
            ((x = parentRect.width * this.relativeRect().x + parentRect.x),
                (y = parentRect.height * this.relativeRect().y + parentRect.y),
                (width = parentRect.width * this.relativeRect().width),
                (height = parentRect.height * this.relativeRect().height));
        }
        return {
            x: viewSize.width * x,
            y: viewSize.height * y,
            width: viewSize.width * width,
            height: viewSize.height * height,
        };
    }

    /**
     * @desc 获得对象带旋转后的矩形大小
     * @param viewSize
     */
    getRectWithAngle(viewSize) {
        let elementRect = this.getRect(viewSize);
        if (this._angle === 0) return elementRect;
        else return FJMathUtil.getRectAfterTransformation(elementRect, this._angle);
    }

    /**
     * @desc move
     * @param offset
     * @param originalRect
     * @param viewSize - 预览画布的尺寸
     * @param otherRects
     * @param isAdsorption
     */
    move(offset, originalRect, viewSize, otherRects, isAdsorption = true) {
        if (!viewSize) return;
        originalRect.x += offset.x;
        originalRect.y += offset.y;

        // 如果是打组内的对象，则需要将_relativeRect还原到相对打组对象的位置
        if (this.groupParent()) {
            if (isAdsorption)
                originalRect = FJMathUtil.adsorption(
                    originalRect,
                    viewSize,
                    otherRects,
                    this.groupParent().angle() + this._angle,
                    FJCoreConfig.adsorptionOffset,
                );
            let groupRect = this.groupParent().getRect(viewSize);
            let rect = this.groupParent().getElementRectToGroup(originalRect, groupRect);
            this._relativeRect.x = rect.x / groupRect.width;
            this._relativeRect.y = rect.y / groupRect.height;
        } else {
            if (isAdsorption)
                originalRect = FJMathUtil.adsorption(
                    originalRect,
                    viewSize,
                    otherRects,
                    this._angle,
                    FJCoreConfig.adsorptionOffset,
                );
            this._relativeRect.x = originalRect.x / viewSize.width;
            this._relativeRect.y = originalRect.y / viewSize.height;
        }
    }

    rotate(currentPoint, oldPoint, viewSize, needAdsorbVal = true) {
        let rect;
        // 得到相对于画布的rect
        if (this._groupParent) {
            let groupRect = this._groupParent.getRect(viewSize);
            rect = this.getRect(groupRect);
            rect = this._groupParent.getElementRectToPage(rect, groupRect);
        } else rect = this.getRect(viewSize);

        let centerPoint = {
            x: rect.x + rect.width / 2,
            y: rect.y + rect.height / 2,
        };
        let curAngle = FJMathUtil.angleAtPoint(currentPoint, centerPoint);
        let orgAngle = FJMathUtil.angleAtPoint(oldPoint, centerPoint);
        let oa = orgAngle - curAngle;
        let newAngle = (this._angle * Math.PI) / 180 + oa;

        if (newAngle < 0) newAngle += 2 * Math.PI;
        else if (newAngle > 2 * Math.PI) newAngle -= 2 * Math.PI;

        let isAdsorbVal = false;
        if (needAdsorbVal) {
            let adsorbVal = 0.05;
            if (Math.abs(newAngle - 2 * Math.PI) < adsorbVal || newAngle < adsorbVal) {
                newAngle = 0;
                isAdsorbVal = true;
            } else if (Math.abs(newAngle - Math.PI / 2) < adsorbVal) {
                newAngle = Math.PI / 2;
                isAdsorbVal = true;
            } else if (Math.abs(newAngle - (Math.PI + Math.PI / 2)) < adsorbVal) {
                newAngle = Math.PI + Math.PI / 2;
                isAdsorbVal = true;
            } else if (Math.abs(newAngle - Math.PI) < adsorbVal) {
                newAngle = Math.PI;
                isAdsorbVal = true;
            }
        }

        this.angle((newAngle * 180) / Math.PI);
        this.drawTrack(FJArchiveUtil.getAuxiliary());
        return isAdsorbVal;
    }

    /**
     * @desc 用于更新可视元素的size，专门用来做透明度检测时，用来更新元素尺寸，因为有时候对象创建透明度image时，元素并未更新大小导致渲染出来的image是全黑的
     * @param viewSize - 父元素的尺寸
     * @return {boolean}
     * @private
     */
    _updateElementSize(viewSize) {
        return false;
    }

    /**
     * @desc 创建用做点击时判断透明度的canvas
     */
    _createHitTestCanvas() {
        if (!this._hitWithAlpha()) return;
        let element = this.element();
        if (!element) return;
        let auxiliary = FJArchiveUtil.getAuxiliary();
        if (!auxiliary) return;
        let viewSize = {
            width: auxiliary.offsetWidth,
            height: auxiliary.offsetHeight,
        };
        if (viewSize.width === 0 || viewSize.height === 0) return;
        if (this.groupParent()) viewSize = this.groupParent().getRect(viewSize);
        if (!this._updateElementSize(viewSize)) return;
        let size = this.getRect(viewSize);
        if (!this._hitTestCanvas) {
            this._hitTestCanvas = document.createElement('canvas');
            this._hitTestCanvas.width = 0;
            this._hitTestCanvas.height = 0;
        }

        let svg = FJArchiveUtil.getSvgWithForeignObject(size);
        let foreignObject = $(svg).find('foreignObject')[0];
        let cloneNode = element.cloneNode(true);
        $(cloneNode).css({
            left: 0,
            top: 0,
            opacity: 1,
            transform: 'rotate(0deg) scale(' + this._flipX + ',' + this._flipY + ')',
        });
        $(foreignObject).append(cloneNode);

        FJImageUtil.loadImage(
            'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(svg)),
        )
            .then(image => {
                this._hitTestCanvas.width = size.width;
                this._hitTestCanvas.height = size.height;
                let ctx = this._hitTestCanvas.getContext('2d');
                ctx.clearRect(0, 0, size.width, size.height);
                ctx.drawImage(image, 0, 0, size.width, size.height);
            })
            .catch(() => {
                this._hitTestCanvas = null;
            });
    }

    isPointInElement(point) {
        let node = this._track.trackNodeAtPoint(point);
        if (node === TrackNode.MOVE && this._hitWithAlpha()) {
            if (this._hitTestCanvas && this._hitTestCanvas.width !== 0 && this._hitTestCanvas.height !== 0) {
                let rgba;
                try {
                    let size = this._track.getTrackSize();
                    if (size.width !== this._alphaCanvas.width || size.height !== this._hitTestCanvas.height) {
                        this._alphaCanvas.width = size.width;
                        this._alphaCanvas.height = size.height;
                        let ctx = this._alphaCanvas.getContext('2d');
                        ctx.drawImage(this._hitTestCanvas, 0, 0, size.width, size.height);
                    }
                    let convertPoint = this._track.convertMousePointToTrack(point);
                    rgba = this._alphaCanvas.getContext('2d').getImageData(convertPoint.x, convertPoint.y, 1, 1).data;
                } catch (e) {
                    return node !== TrackNode.NONE;
                }
                return rgba[3] !== 0;
            } else {
                return node !== TrackNode.NONE;
            }
        } else {
            if (!this.isSelected() && node === TrackNode.ROTATE) {
                return false;
            }
            return node !== TrackNode.NONE;
        }
    }

    /**
     * @desc 是否选中了resize，旋转的操作节点
     * @param point
     */
    isPointInElementSpecialNode(point) {
        let node = this._track.trackNodeAtPoint(point);
        return node !== -1 && node !== 9 && !this._isGroup;
    }

    /**
     * @desc 对象是否与rect有交集
     * @param {*} view - 所在的图层
     * @param {{}} rect - 是否有交集的rect
     * @param {boolean} hasAngle - 是否计算旋转
     */
    isRectIntersectionInView(view, rect, hasAngle = true) {
        const size = view.getBoundingClientRect();
        let elementRect = this.getRect({
            width: size.width,
            height: size.height,
        });
        if (!elementRect) return false;
        let centerPoint = {
            x: elementRect.x + elementRect.width / 2,
            y: elementRect.y + elementRect.height / 2,
        };
        let leftTop, rightTop, rightBottom, leftBottom;
        if (hasAngle) {
            leftTop = FJMathUtil.convertPointByAngle({ x: elementRect.x, y: elementRect.y }, centerPoint, -this._angle);
            rightTop = FJMathUtil.convertPointByAngle(
                {
                    x: elementRect.x + elementRect.width,
                    y: elementRect.y,
                },
                centerPoint,
                -this._angle,
            );
            rightBottom = FJMathUtil.convertPointByAngle(
                {
                    x: elementRect.x + elementRect.width,
                    y: elementRect.y + elementRect.height,
                },
                centerPoint,
                -this._angle,
            );
            leftBottom = FJMathUtil.convertPointByAngle(
                {
                    x: elementRect.x,
                    y: elementRect.y + elementRect.height,
                },
                centerPoint,
                -this._angle,
            );
        } else {
            leftTop = { x: elementRect.x, y: elementRect.y };
            rightTop = { x: elementRect.x + elementRect.width, y: elementRect.y };
            rightBottom = {
                x: elementRect.x + elementRect.width,
                y: elementRect.y + elementRect.height,
            };
            leftBottom = {
                x: elementRect.x,
                y: elementRect.height + elementRect.height,
            };
        }
        // 对象的点是否在矩形范围内
        if (
            FJMathUtil.isPointInRect(leftTop, rect) ||
            FJMathUtil.isPointInRect(rightTop, rect) ||
            FJMathUtil.isPointInRect(rightBottom, rect) ||
            FJMathUtil.isPointInRect(leftBottom, rect)
        )
            return true;

        // 是否相交
        if (
            FJMathUtil.intersectsLineWithRect(leftTop, rightTop, rect) ||
            FJMathUtil.intersectsLineWithRect(rightTop, rightBottom, rect) ||
            FJMathUtil.intersectsLineWithRect(rightBottom, leftBottom, rect) ||
            FJMathUtil.intersectsLineWithRect(leftBottom, leftTop, rect)
        )
            return true;

        // 框选的点是否在对象的范围内
        let sLeftTop = { x: rect.x, y: rect.y },
            sRightTop = { x: rect.x + rect.width, y: rect.y },
            sRightBottom = { x: rect.x + rect.width, y: rect.y + rect.height },
            sLeftBottom = { x: rect.x, y: rect.y + rect.height };
        if (hasAngle) {
            sLeftTop = FJMathUtil.convertPointByAngle(sLeftTop, centerPoint, this._angle);
            sRightTop = FJMathUtil.convertPointByAngle(sRightTop, centerPoint, this._angle);
            sRightBottom = FJMathUtil.convertPointByAngle(sRightBottom, centerPoint, this._angle);
            sLeftBottom = FJMathUtil.convertPointByAngle(sLeftBottom, centerPoint, this._angle);
        }

        return !!(
            FJMathUtil.isPointInRect(sLeftTop, elementRect) ||
            FJMathUtil.isPointInRect(sRightTop, elementRect) ||
            FJMathUtil.isPointInRect(sRightBottom, elementRect) ||
            FJMathUtil.isPointInRect(sLeftBottom, elementRect)
        );
    }

    /**
     * @desc resize时保持fixNode的点不变
     * @param {FixNode} fixNode - 要保持不动的点
     * @param renderRect - 实际预览时渲染的rect
     * @param {{width, height}} viewSize - 画布的实际大小
     * @param {number} angle - 旋转角度
     * @return {*}
     * @private
     */
    _updateAxisOfNode(fixNode, renderRect, viewSize, angle) {
        let oldRect = this.getRect(viewSize);
        let axis = {
            x: oldRect.x + oldRect.width / 2,
            y: oldRect.y + oldRect.height / 2,
        };
        let dx, dy;

        switch (fixNode) {
            case FixNode.FixedNode_RIGHT_TOP: {
                dx = oldRect.x + oldRect.width - axis.x;
                dy = oldRect.y - axis.y;
                axis.x = renderRect.x + renderRect.width - dx;
                axis.y = renderRect.y - dy;
                break;
            }
            case FixNode.FixedNode_LEFT_TOP: {
                dx = oldRect.x - axis.x;
                dy = oldRect.y - axis.y;
                axis.x = renderRect.x - dx;
                axis.y = renderRect.y - dy;
                break;
            }
            case FixNode.FixedNode_RIGHT_BOTTOM: {
                dx = oldRect.x + oldRect.width - axis.x;
                dy = oldRect.y + oldRect.height - axis.y;
                axis.x = renderRect.x + renderRect.width - dx;
                axis.y = renderRect.y + renderRect.height - dy;
                break;
            }
            case FixNode.FixedNode_LEFT_BOTTOM: {
                dx = oldRect.x - axis.x;
                dy = oldRect.y + oldRect.height - axis.y;
                axis.x = renderRect.x - dx;
                axis.y = renderRect.y + renderRect.height - dy;
                break;
            }
            default:
                break;
        }
        // 根据角度重新计算x，y的位置
        let __updateRotateCenter = (oldCenter, renderRect) => {
            let newCenter = {
                x: renderRect.x + renderRect.width / 2,
                y: renderRect.y + renderRect.height / 2,
            };
            if (newCenter.x !== oldCenter.x || newCenter.y !== oldCenter.y) {
                let convertPoint = FJMathUtil.convertPointByAngle(newCenter, oldCenter, -angle);
                let ox = convertPoint.x - newCenter.x,
                    oy = convertPoint.y - newCenter.y;
                renderRect.x += ox;
                renderRect.y += oy;
            }
            return renderRect;
        };
        return __updateRotateCenter(axis, renderRect);
    }

    /**
     *
     * @param node
     NONE: -1,
     LEFT_TOP: 0,
     TOP: 1,
     RIGHT_TOP: 2,
     RIGHT: 3,
     RIGHT_BOTTOM: 4,
     BOTTOM: 5,
     LEFT_BOTTOM: 6,
     LEFT: 7,
     * @param offset
     * @param viewSize
     */
    resize(offset, node, viewSize, options = {}) {
        let ox = offset.x,
            oy = offset.y;
        let rect = this.getRect(viewSize);
        let ratio = rect.width / rect.height;
        // 如果有旋转的话，表示保持不动的是哪个点
        let fixNode = null;
        switch (node) {
            case TrackNode.LEFT_TOP:
                if ((ox > 0 && oy < 0) || (ox < 0 && oy > 0)) return;
                if (ratio >= 1.002) {
                    oy = ox / ratio;
                } else {
                    ox = oy * ratio;
                }
                rect.width -= ox;
                rect.height -= oy;
                rect.x += ox;
                rect.y += oy;

                fixNode = FixNode.FixedNode_RIGHT_BOTTOM;
                break;
            case TrackNode.TOP:
                rect.y += oy;
                rect.height -= oy;

                fixNode = FixNode.FixedNode_LEFT_BOTTOM;
                break;
            case TrackNode.RIGHT_TOP:
                if ((ox > 0 && oy > 0) || (ox < 0 && oy < 0)) return;
                if (ratio >= 1.002) {
                    oy = -ox / ratio;
                } else {
                    ox = -oy * ratio;
                }

                rect.width += ox;
                rect.height -= oy;
                rect.y += oy;

                fixNode = FixNode.FixedNode_LEFT_BOTTOM;
                break;
            case TrackNode.RIGHT:
                rect.width += ox;
                fixNode = FixNode.FixedNode_LEFT_TOP;
                break;
            case TrackNode.RIGHT_BOTTOM:
                if ((ox > 0 && oy < 0) || (ox < 0 && oy > 0)) return;

                if (ratio >= 1.002) {
                    oy = ox / ratio;
                } else {
                    ox = oy * ratio;
                }

                rect.width += ox;
                rect.height += oy;

                fixNode = FixNode.FixedNode_LEFT_TOP;
                break;
            case TrackNode.BOTTOM:
                rect.height += oy;
                fixNode = FixNode.FixedNode_LEFT_TOP;
                break;
            case TrackNode.LEFT_BOTTOM:
                if ((ox > 0 && oy > 0) || (ox < 0 && oy < 0)) return;
                if (ratio >= 1.002) {
                    oy = -ox / ratio;
                } else {
                    ox = -oy * ratio;
                }
                rect.width -= ox;
                rect.height += oy;
                rect.x += ox;

                fixNode = FixNode.FixedNode_RIGHT_TOP;
                break;
            case TrackNode.LEFT:
                rect.x += ox;
                rect.width -= ox;
                fixNode = FixNode.FixedNode_RIGHT_BOTTOM;
                break;
            default:
        }

        let angle = this._angle;
        // if (this.groupParent())
        //     angle += this.groupParent().angle();

        if (angle !== 0 && fixNode) {
            rect = this._updateAxisOfNode(fixNode, rect, viewSize, angle);
        }

        // 目前只支持0°和180°的旋转缩放吸附
        if (angle === 0 || angle === 180) {
            let resizeNode = node;
            if (angle === 180) {
                switch (node) {
                    case TrackNode.LEFT_TOP:
                        resizeNode = TrackNode.RIGHT_BOTTOM;
                        break;
                    case TrackNode.TOP:
                        resizeNode = TrackNode.BOTTOM;
                        break;
                    case TrackNode.RIGHT_TOP:
                        resizeNode = TrackNode.LEFT_BOTTOM;
                        break;
                    case TrackNode.RIGHT:
                        resizeNode = TrackNode.LEFT;
                        break;
                    case TrackNode.RIGHT_BOTTOM:
                        resizeNode = TrackNode.LEFT_TOP;
                        break;
                    case TrackNode.BOTTOM:
                        resizeNode = TrackNode.TOP;
                        break;
                    case TrackNode.LEFT_BOTTOM:
                        resizeNode = TrackNode.RIGHT_TOP;
                        break;
                    case TrackNode.LEFT:
                        resizeNode = TrackNode.RIGHT;
                        break;
                }
            }
            const oldRect = this.getRect(viewSize);
            rect = FJUtil.adsorption2(oldRect, rect, viewSize, options?.otherRects, resizeNode);
        }

        return this._convertRectToRelativeRect(viewSize, rect);
    }

    /**
     * @desc
     * @param currentTime - 当前故事板的时间，单位s
     */
    play(currentTime) {}

    pause() {}

    seek(value, isFrame) {}

    stop() {}

    reset() {}

    select() {
        this._selected = true;
        this.drawTrack(FJArchiveUtil.getAuxiliary());
    }

    setSelect(value) {
        this._selected = value;
    }

    /**
     * @desc 取消选中
     */
    deselect() {
        this._selected = false;
        this.clearTrack();
    }

    isGroup(value) {
        if (typeof value === 'undefined') return this._isGroup;
        else this._isGroup = value;
    }

    isSelected() {
        return this._selected;
    }

    clearTrack() {
        this._track.clear();
    }

    delete() {
        FJSprite.updateResizeCursor();
        this.removeFromView();
        // this.clear();
    }

    clear() {}

    /**
     * @desc 是否显示track的旋转节点
     * @param boolean
     */
    setHasRotationNode(boolean) {
        this._track.setHasRotationNode(boolean);
    }

    updateTrackRect(viewSize) {
        if (viewSize) {
            let rect,
                angle = this._angle;
            if (this._groupParent) {
                let groupRect = this._groupParent.getRect(viewSize);
                rect = this.getRect(groupRect);
                if (rect) rect = this._groupParent.getElementRectToPage(rect, groupRect);
                angle += this._groupParent.angle();
            } else rect = this.getRect(viewSize);
            if (rect) this._track.updateTrack(false, rect, angle, viewSize);
        }
    }

    drawTrack(view, options = {}) {
        if (view) {
            let viewSize = { width: view.offsetWidth, height: view.offsetHeight };
            let rect;
            let isSelectedGroup = false; // 选中了打组对象
            let isSelectedBrotherElementInGroup = false; // 是否选中了打组对象中的元素，且是自己的兄弟元素
            let isMultipleBrotherElementInGroup = false; // 是否多选中打组对象中的元素，且是自己的兄弟元素
            let isMultipleInGroup = false; // 是否多选中打组对象中的元素
            let angle = this._angle;
            if (this._groupParent) {
                let selectedElementInGroup = this._groupParent.selectedElement();
                isSelectedBrotherElementInGroup = selectedElementInGroup && selectedElementInGroup !== this;
                isSelectedGroup = this._groupParent.isSelected();

                const groupAllElement = this._groupParent.getAllElements();
                const groupMultipleElement = groupAllElement.filter(ele => ele.isGroup());
                isMultipleInGroup = groupMultipleElement.length > 0;
                isMultipleBrotherElementInGroup = groupMultipleElement.findIndex(ele => ele === this) === -1;

                let groupRect = this._groupParent.getRect(viewSize);
                rect = this.getRect(groupRect);
                if (rect) rect = this._groupParent.getElementRectToPage(rect, groupRect);
                angle += this._groupParent.angle();
            } else rect = this.getRect(viewSize);
            if (rect) {
                const isJustRenderLine =
                    this._isLock ||
                    this._isGroup ||
                    options.isJustRenderLine ||
                    (!this._selected &&
                        !isMultipleInGroup &&
                        !isMultipleBrotherElementInGroup &&
                        isSelectedGroup &&
                        !isSelectedBrotherElementInGroup);
                const isSelected = !this._isLock && this._selected && !this._isGroup;
                this._track.draw(view, {
                    selected: isSelected,
                    trackRect: rect,
                    angle: angle,
                    isCanRender: isSelected || isJustRenderLine || this._isGroup,
                    isJustRenderLine: isJustRenderLine,
                    opacity: 1,
                    isDottedLine: this._isLock || isSelectedGroup || this._type === FJViewConstant.GRAPH_WEBGL_EFFECT,
                    lineStyle: this._isLock ? { color: '#32E7FF' } : undefined,
                });
            }
        }
    }

    drawTrackWithMouseOver(view) {
        if (view) {
            let viewSize = { width: view.offsetWidth, height: view.offsetHeight };
            let rect,
                angle = this._angle;

            let isSelfMultipleInGroup = false; // 是否自己是 多选中打组对象中的元素

            if (this._groupParent) {
                let groupRect = this._groupParent.getRect(viewSize);
                rect = this.getRect(groupRect);
                if (rect) rect = this._groupParent.getElementRectToPage(rect, groupRect);
                angle += this._groupParent.angle();

                const groupAllElement = this._groupParent.getAllElements();
                const groupMultipleElement = groupAllElement.filter(ele => ele.isGroup());
                isSelfMultipleInGroup =
                    groupMultipleElement.length > 0 && groupMultipleElement.find(ele => ele === this);
            } else rect = this.getRect(viewSize);
            if (rect) {
                const isSelected = !this._isLock && this._selected && !this._isGroup;
                const isJustRenderLine = this._isLock || !this._selected || this._isGroup;
                this._track.draw(view, {
                    selected: isSelected,
                    trackRect: rect,
                    angle: angle,
                    isCanRender: isSelected || isJustRenderLine || this._isGroup,
                    isJustRenderLine: isJustRenderLine,
                    opacity: 1,
                    isDottedLine: this._isLock || isSelfMultipleInGroup,
                    lineStyle: this._isLock ? { color: '#32E7FF' } : undefined,
                });
            }
        }
    }

    updateTrack(view) {
        let isSelectedGroup = this._groupParent && this._groupParent.isSelected();
        // 当没有选中，且不是多选中,且打组对象也没有被选中的就清空track
        if (!this._selected && !this._isGroup && !isSelectedGroup) {
            if (view) {
                let viewSize = { width: view.offsetWidth, height: view.offsetHeight };
                this.updateTrackRect(viewSize);
            }
            this._track.clear();
        } else this.drawTrack(view);
    }

    /**
     * @desc 获得当前坐标所在的节点
     * @param point
     * @return {number|number}
     */
    getTrackNodeByPoint(point) {
        if (this._isLock) return TrackNode.NONE;
        else if (!this._canResize()) return TrackNode.MOVE;

        const node = this._track.trackNodeAtPoint(point);
        if (this._isGroup) {
            if (node === TrackNode.NONE || node === TrackNode.MOVE) return node;
            else if (node === TrackNode.ROTATE) return TrackNode.NONE;
            else return TrackNode.MOVE;
        } else return node;
    }

    /**
     * 元素是否可以 resize，如果元素未选中且元素尺寸过小，那么只允许 move
     * @returns {boolean}
     * @private
     */
    _canResize() {
        const rect = this.getElementRenderRect();
        if (!this._selected && rect && (rect.width < 30 || rect.height < 30)) {
            return false;
        }
        return true;
    }

    getType() {
        return this._type;
    }

    getOwner() {
        return this._owner;
    }

    getBoardName() {
        try {
            let board = this._owner;
            while (!board.boardName) {
                board = board.getOwner();
            }
            return board.boardName();
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    setOwner(owner) {
        this._owner = owner;
    }

    changeCursorByPoint(point) {
        if (this._isLock) {
            FJUtil.updateCursor('auto');
        } else {
            let node = this.getTrackNodeByPoint(point);
            let angle = this._angle;
            if (this.groupParent()) angle += this.groupParent().angle();
            let trackNode = FJTrack.cursorOfAngle(angle, node);
            FJSprite.updateResizeCursor(trackNode);
        }
    }

    getId() {
        return this._id;
    }

    position(position) {
        let { width, height } = this._relativeRect;
        let adsorptionOffset = FJCoreConfig.adsorptionOffsetRatio;
        switch (position) {
            case FJViewConstant.LEFT_TOP:
                this._relativeRect.x = adsorptionOffset;
                this._relativeRect.y = adsorptionOffset;
                break;
            case FJViewConstant.TOP:
                this._relativeRect.x = (1 - width) / 2;
                this._relativeRect.y = adsorptionOffset;
                break;
            case FJViewConstant.RIGHT_TOP:
                this._relativeRect.x = 1 - adsorptionOffset - width;
                this._relativeRect.y = adsorptionOffset;
                break;
            case FJViewConstant.LEFT:
                this._relativeRect.x = adsorptionOffset;
                this._relativeRect.y = (1 - height) / 2;
                break;
            case FJViewConstant.CENTER:
                this._relativeRect.x = (1 - width) / 2;
                this._relativeRect.y = (1 - height) / 2;
                break;
            case FJViewConstant.RIGHT:
                this._relativeRect.x = 1 - adsorptionOffset - width;
                this._relativeRect.y = (1 - height) / 2;
                break;
            case FJViewConstant.LEFT_BOTTOM:
                this._relativeRect.x = adsorptionOffset;
                this._relativeRect.y = 1 - adsorptionOffset - height;
                break;
            case FJViewConstant.BOTTOM:
                this._relativeRect.x = (1 - width) / 2;
                this._relativeRect.y = 1 - adsorptionOffset - height;
                break;
            case FJViewConstant.RIGHT_BOTTOM:
                this._relativeRect.x = 1 - adsorptionOffset - width;
                this._relativeRect.y = 1 - adsorptionOffset - height;
                break;
            default:
                break;
        }

        this.updateView();
    }

    alignInCanvas(type, viewSize) {
        this._alignRelativeRect(type, viewSize);
        this.updateView();
    }

    _alignRelativeRect(type, viewSize) {
        const relativeRect = { ...this._relativeRect };
        const adsorptionOffset = 0; //FJCoreConfig.adsorptionOffsetRatio;
        const rect = this.getRect(viewSize);
        const rectWithAngle = this.getRectWithAngle(viewSize);
        switch (type) {
            case FJViewConstant.POSITION_TOP:
                relativeRect.y = adsorptionOffset + (rectWithAngle.height - rect.height) / 2 / viewSize.height;
                break;
            case FJViewConstant.POSITION_BOTTOM:
                relativeRect.y =
                    1 -
                    adsorptionOffset -
                    relativeRect.height -
                    (rectWithAngle.height - rect.height) / 2 / viewSize.height;
                break;
            case FJViewConstant.POSITION_LEFT:
                relativeRect.x = adsorptionOffset + (rectWithAngle.width - rect.width) / 2 / viewSize.width;
                break;
            case FJViewConstant.POSITION_RIGHT:
                relativeRect.x =
                    1 - adsorptionOffset - relativeRect.width - (rectWithAngle.width - rect.width) / 2 / viewSize.width;
                break;
            case FJViewConstant.POSITION_CENTER_HORIZONTAL:
                relativeRect.x = (1 - relativeRect.width) / 2;
                break;
            case FJViewConstant.POSITION_CENTER_VERTICAL:
                relativeRect.y = (1 - relativeRect.height) / 2;
                break;
        }
        this._relativeRect = relativeRect;
    }

    /**
     * @desc 准备输出
     * @param size
     */
    prepareToExport(size, force) {
        if (this._isExport && !force) return;

        // 此处进行 reset 的目的便是清除其内部的 begin 判断，从而避免第一次 seek 时触发到 changeComplete
        // this.reset(true);

        if (!this._exportView) {
            this._exportView = FJArchiveUtil.createExportViewWithSize(size);
            document.body.appendChild(this._exportView);
        }
        $(this._exportView).empty();
        // 将文字对象添加到输出视图中
        if (this.groupParent()) {
            // 判断是否是组合对象
            const viewSize = { ...size };
            const groupRect = this.groupParent().getRect(viewSize);

            // 创建容器层
            const container = document.createElement('div');
            $(container).css({
                position: 'absolute',
                left: groupRect.x,
                top: groupRect.y,
                width: groupRect.width,
                height: groupRect.height,
            });

            // 创建motion层
            const motion = document.createElement('div');
            $(motion).css({
                position: 'absolute',
            });
            container.appendChild(motion);

            this._exportView.appendChild(container);
            this.addToView(motion, groupRect);
        } else {
            this.addToView(this._exportView, size);
        }

        // 输出时先设置 visibility
        this.visibility(true);

        this._isExport = true;
    }

    /**
     * @desc 结束输出
     */
    stopExport() {
        if (this._isExport) {
            this._isExport = false;
            this._clearExportView();
        }
    }

    /**
     * @desc 获取元素内容层dom
     * @return {null|*}
     */
    getContentDom() {
        if (!this._isExport) return null;

        let content = this._getExportDom();

        // 存在输出中视图被加到body中的情况，此时需要将其重新加入到输出视图中
        if (!content && this.element()) {
            const viewSize = { width: this._exportView.offsetWidth, height: this._exportView.offsetHeight };
            this.prepareToExport(viewSize, true);
            content = this._getExportDom();
        }

        return content;
    }

    /**
     * @desc 获取输出的dom
     * @returns {*|null}
     * @private
     */
    _getExportDom() {
        let exportView = this._exportView;
        const parent = this.groupParent();
        if (parent) {
            const groupContainer = this._exportView.getElementsByTagName('div')[0];
            if (!groupContainer) return null;
            const groupContent = groupContainer.getElementsByTagName('div')[0];
            if (!groupContent) return null;

            exportView = groupContent;
        }

        const container = exportView.getElementsByTagName('div')[0];
        if (!container) return null;
        let content = container.getElementsByTagName('div')[0];
        if (!content || this.isExpandMotionContainer()) {
            content = container.getElementsByTagName('svg')[0];
        }

        return content;
    }

    getDomInfo() {
        const ele = this.element();
        const elementData = ele ? ele.outerHTML : ele;
        const exportViewData = this._exportView ? this._exportView.innerHTML : '';
        return `isExport=${this._isExport}, html = ${exportViewData}, element = ${elementData}`;
    }

    /**
     * @desc 渲染内容层canvas到指定canvas
     * @param contentFrame
     * @param time
     * @param canvas
     * @param domSize, 内容层大小
     * @param contentExpandSize, 内容层渲染时的扩展大小
     * @return {boolean|HTMLCanvasElement}
     */
    drawContentFrameAtTimeToCanvas(contentFrame, time, canvas, domSize, contentExpandSize) {
        if (!this._isExport) return false;

        this.renderAtTime(time);

        // 特殊文字动画处理
        this._handleSpecialAnimation && this._handleSpecialAnimation(time);

        const contentDom = this.getContentDom();
        if (!contentDom) return false;

        // 将内容层canvas添加到与内容层dom同层级，并设置相同的style
        const parentDom = contentDom.parentNode;
        const parentStyle = parentDom.style.cssText;
        parentDom.style.cssText = parentStyle + 'font-size: 0;';
        parentDom.removeChild(contentDom);
        parentDom.appendChild(contentFrame);

        // 用canvas替换dom时可能尺寸不对，导致整个dom的尺寸发生改变，因此需要将canvas设置成跟原dom一样的尺寸
        contentFrame.style.cssText =
            contentDom.style.cssText + 'width: ' + domSize.width + 'px; height: ' + domSize.height + 'px';

        // TODO： 部分动画属性会在 animejs 中被其他动画继承，导致动画效果不正确，目前发现的perspective属性会有影响
        if (this._judgeCurrentTimeIsInAnimation && !this._judgeCurrentTimeIsInAnimation(time)) {
            // 删除 transform 中的 perspective 属性
            contentFrame.style.cssText = FJMotionUtil.removeTransformFunctions(
                contentFrame.style.cssText,
                'perspective',
            );
        }

        // 渲染内容层canvas到指定canvas
        const parent = this.groupParent();
        const ret = FJDomCanvasRender.renderDomToCanvas(this._exportView, canvas, !!parent, contentExpandSize, {
            id: this._id,
            usePublic: true,
            isExpandMotionContainer: this.isExpandMotionContainer(),
        });

        // 还原dom
        parentDom.style.cssText = parentStyle;
        contentFrame.style.cssText = '';
        parentDom.removeChild(contentFrame);
        parentDom.appendChild(contentDom);

        return ret;
    }

    /**
     * @desc 判断元素内容层是否在指定时间静止
     * @param time
     * @return {boolean}
     */
    isContentStaticAtTime(time) {
        return true;
    }

    /**
     * @desc 渲染指定时间的帧
     * @param time
     */
    renderAtTime(time) {
        if (!this._isExport) return;

        const parent = this.groupParent();
        if (parent) {
            parent.drawChildToExportViewAtTime(this, this._exportView, time);
        }

        this.seek(time);
    }
    /**
     * @desc 渲染内部动画
     * @param time
     */
    renderInternalAtTime(time) {
        if (!this._isExport) return;
        const parent = this.groupParent();
        if (parent) {
            parent.drawChildToExportViewAtTime(this, this._exportView, time);
        }

        this.seekInternal(time);
    }
    /**
     * @desc 内部动画seek
     * @param time
     */
    seekInternal(time) {
        this.seek(time);
    }

    hideExportView() {
        if (this._exportView) $(this._exportView).hide();
    }

    _clearExportView() {
        if (this._exportView && this._exportView.parentNode) this._exportView.parentNode.removeChild(this._exportView);
        this._exportView = null;
    }

    visibility(visible) {
        this._visibility = visible;
        const element = this.element();
        if (element) {
            if (visible) {
                element.classList.remove('u-opacity-0');
            } else {
                element.classList.add('u-opacity-0');
            }
        }
    }

    /**
     * @description 获取实际的尺寸信息
     * @param viewSize 容器尺寸
     */
    getRealRect(viewSize) {
        if (!this._relativeRect) return null;
        if (!viewSize) return null;

        let { x, y, width, height } = this._relativeRect;
        if (this.groupParent && this.groupParent()) {
            let parentRect = this.groupParent().getRelativeRect();
            ((x = parentRect.width * this.relativeRect().x + parentRect.x),
                (y = parentRect.height * this.relativeRect().y + parentRect.y),
                (width = parentRect.width * this.relativeRect().width),
                (height = parentRect.height * this.relativeRect().height));
        }
        return {
            x: viewSize.width * x,
            y: viewSize.height * y,
            width: viewSize.width * width,
            height: viewSize.height * height,
        };
    }

    getCoverRect(viewSize) {
        const { x, y, width, height } = this._relativeRect;
        const rx = viewSize.width * x;
        const ry = viewSize.height * y;
        const rw = viewSize.width * width;
        const rh = viewSize.height * height;
        const offset = Math.max(rw, rh) * 0.2;
        return {
            offset,
            x: rx - offset,
            y: ry - offset,
            width: rw + offset * 2,
            height: rh + offset * 2,
        };
    }

    _getCoverInfo() {
        const json = JSON.parse(JSON.stringify(this.toJSON()));

        // 封面帧不需要考虑 id、x、y 等属性
        json?.id && delete json.id;
        json?.relativeRect?.x && delete json.relativeRect.x;
        json?.relativeRect?.y && delete json.relativeRect.y;

        return json;
    }

    createCoverKey(size) {
        const { width, height } = size;
        const json = this._getCoverInfo();
        return FJUtil.hashValue(`${JSON.stringify(json)}-${width}-${height}`);
    }

    createCoverFrame() {}

    /**
     * @description 得到link的样式
     * @param {boolean} hasIcon
     * @returns {HTMLDivElement}
     */
    _createLinkView(hasIcon = true) {
        let linkEle = document.createElement('div');
        $(linkEle).css({
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            background: hasIcon ? 'rgba(0, 0, 0, 0.08)' : 'rgba(0, 0, 0, 0)',
            transform: 'scale(1, 1)',
        });
        if (!hasIcon) {
            return linkEle;
        }

        let linkNode = document.createElement('div');
        $(linkNode).css({
            position: 'absolute',
            width: 26 + 'px',
            height: 26 + 'px',
            left: '50%',
            top: '50%',
            marginLeft: -13 + 'px',
            marginTop: -13 + 'px',
        });

        let _linkSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        $(_linkSVG).attr({
            width: 24,
            height: 24,
            viewBox: '0 0 24 24',
        });
        $(_linkSVG).css({
            position: 'absolute',
            left: '50%',
            top: '50%',
            marginLeft: '-12px',
            marginTop: '-12px',
        });

        let g1 = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        $(g1).attr({
            stroke: 'none',
            'stroke-width': 1,
            fill: 'none',
        });

        let path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        $(path1).attr({
            fill: FJCoreConfig.trackLinkNormalColor,
            d: 'M16.0524738,6.3 C19.1894352,6.3 21.75,8.86377752 21.75,11.9975262 C21.75,15.1344876 19.1862225,17.6950524 16.0524738,17.6950524 L14.6941528,17.6950524 C14.2799392,17.6950524 13.9441528,17.3592659 13.9441528,16.9450524 C13.9441528,16.5308388 14.2799392,16.1950524 14.6941528,16.1950524 L16.0524738,16.1950524 C18.3582161,16.1950524 20.25,14.3056391 20.25,11.9975262 C20.25,9.69178389 18.3605868,7.8 16.0524738,7.8 L14.6941528,7.8 C14.2799392,7.8 13.9441528,7.46421356 13.9441528,7.05 C13.9441528,6.63578644 14.2799392,6.3 14.6941528,6.3 L16.0524738,6.3 Z M9.30584721,6.3 C9.72006077,6.3 10.0558472,6.63578644 10.0558472,7.05 C10.0558472,7.46421356 9.72006077,7.8 9.30584721,7.8 L7.94752618,7.8 C5.63941324,7.8 3.75,9.69178389 3.75,11.9975262 C3.75,14.3056391 5.64178389,16.1950524 7.94752618,16.1950524 L9.30584721,16.1950524 C9.72006077,16.1950524 10.0558472,16.5308388 10.0558472,16.9450524 C10.0558472,17.3592659 9.72006077,17.6950524 9.30584721,17.6950524 L7.94752618,17.6950524 C4.81377752,17.6950524 2.25,15.1344876 2.25,11.9975262 C2.25,8.86377752 4.81056477,6.3 7.94752618,6.3 Z M15.6024877,11.2475262 C16.0167012,11.2475262 16.3524877,11.5833126 16.3524877,11.9975262 C16.3524877,12.4117397 16.0167012,12.7475262 15.6024877,12.7475262 L8.40608596,12.7475262 C7.9918724,12.7475262 7.65608596,12.4117397 7.65608596,11.9975262 C7.65608596,11.5833126 7.9918724,11.2475262 8.40608596,11.2475262 L15.6024877,11.2475262 Z',
            class: 'path',
        });

        g1.appendChild(path1);
        _linkSVG.appendChild(g1);
        linkNode.appendChild(_linkSVG);
        linkEle.appendChild(linkNode);
        return linkEle;
    }
    /**
     * @description 判断是不是在link的icon上面
     * @param point
     * @param rect
     * @returns {boolean}
     */
    _isPointInLinkIcon(point, rect) {
        if (!point || !rect) {
            return false;
        }
        let centerPosition = {
            x: rect.x + rect.width / 2,
            y: rect.y + rect.height / 2,
        };
        let x = centerPosition.x - 13;
        let y = centerPosition.y - 13;
        let w = centerPosition.x + 13;
        let h = centerPosition.y + 13;
        return x <= point.x && w >= point.x && y <= point.y && h >= point.y;
    }
    /**
     * @desc 是否是扩展动画容器
     * @return {boolean}
     */
    isExpandMotionContainer() {
        return false;
    }
    getDrawViewSize() {
        let view = FJComponentUtil.getElementView(FJViewConstant.MAIN_VIEW);
        const rect = FJComponentUtil.getElementViewSize(view);
        return rect;
    }

    _getContainerSize(viewSize) {
        const { width, height } = this.getRect(viewSize);
        return { width, height };
    }

    /**
     * @description 获取元素的canvas
     * @param {*} viewSize
     * @param {*} options
     * @param {number} options.offsetTime
     * @returns {HTMLCanvasElement | null}
     */
    getElementCanvas(viewSize, options = {}) {
        return null;
    }

    /**
     * @description 应用容器层样式到context中
     * @param {Object} containerStyle - 容器层样式对象
     * @param {CanvasRenderingContext2D} ctx - Canvas上下文
     * @param {Object} data - 包含 px, py, preHandleOpacity, width, height
     * @return {{px: number, py: number, opacity: number}}
     * @private
     */
    _applyContainerStyleToContext(containerStyle, ctx, data) {
        const { px, py, preHandleOpacity, width, height, groupExpandSize } = data;

        const transforms = containerStyle.transform.split(') ');
        const opacity = containerStyle.opacity ? parseFloat(containerStyle.opacity) : 1;
        let newPx = px + parseFloat(containerStyle.left || 0);
        let newPy = py + parseFloat(containerStyle.top || 0);

        // 应用透明度
        preHandleOpacity && (ctx.globalAlpha *= opacity);

        // 应用 transform - 中心点固定在容器中心
        transforms.forEach(transform => {
            if (transform.indexOf('translate(') !== -1) {
                const translate = transform.replace('translate(', '');
                const translates = translate.split(',');
                const translateX = parseFloat(translates[0]);
                const translateY = translates.length > 1 ? parseFloat(translates[1]) : translateX;

                if (translates[0].indexOf('%') !== false) {
                    // 百分比
                    ctx.translate((width * translateX) / 100, (height * translateY) / 100);
                } else {
                    ctx.translate(translateX, translateY);
                }
            } else if (transform.indexOf('translateX') !== -1) {
                const translateX = parseFloat(transform.replace('translateX(', ''));
                const isPercentage = transform.indexOf('%') !== false;
                if (isPercentage) {
                    ctx.translate((width * translateX) / 100, 0);
                } else {
                    ctx.translate(translateX, 0);
                }
            } else if (transform.indexOf('translateY') !== -1) {
                const translateY = parseFloat(transform.replace('translateY(', ''));
                const isPercentage = transform.indexOf('%') !== false;
                if (isPercentage) {
                    ctx.translate(0, (height * translateY) / 100);
                } else {
                    ctx.translate(0, translateY);
                }
            } else if (transform.indexOf('rotate') !== -1) {
                const degree = parseFloat(transform.replace('rotate(', ''));
                const angleInRadians = (degree * Math.PI) / 180;

                const ox = newPx + width / 2 + groupExpandSize.horizontal;
                const oy = newPy + height / 2 + groupExpandSize.vertical;

                ctx.translate(ox, oy);
                ctx.rotate(angleInRadians);
                ctx.translate(-ox, -oy);
            } else if (transform.indexOf('scale') !== -1) {
                transform = transform.replace('scale(', '');
                const scales = transform.split(',');
                const scaleX = parseFloat(scales[0]);
                const scaleY = scales.length > 1 ? parseFloat(scales[1]) : scaleX;

                const ox = newPx + width / 2;
                const oy = newPy + height / 2;

                ctx.translate(ox, oy);
                ctx.scale(scaleX, scaleY);
                ctx.translate(-ox, -oy);
            }
        });

        // 裁剪
        if (containerStyle.overflow === 'hidden') {
            ctx.beginPath();
            ctx.rect(newPx + groupExpandSize.horizontal, newPy + groupExpandSize.vertical, width, height);
            ctx.clip();
        }

        return { px: newPx, py: newPy, opacity };
    }

    /**
     * @description 应用动画层样式到context中
     * @param {Object} animeStyle - 动画层样式对象
     * @param {CanvasRenderingContext2D} ctx - Canvas上下文
     * @param {Object} data - 包含 px, py, preHandleOpacity, width, height
     * @return {{px: number, py: number, opacity: number, clipPath: string, is3DMotion: boolean, Motion3DData: Object, targetOffset: Object}}
     * @private
     */
    _applyAnimationStyleToContext(animeStyle, ctx, data) {
        const { px, py, preHandleOpacity, width, height } = data;

        const transforms = animeStyle.transform.split(' ');
        const opacity = animeStyle.opacity ? parseFloat(animeStyle.opacity) : 1;
        const origin = animeStyle.transformOrigin || 'center center';

        // 计算 targetOffset
        const targetOffset = {
            x: parseFloat(animeStyle.left || 0),
            y: parseFloat(animeStyle.top || 0),
        };

        let x = px + targetOffset.x;
        let y = py + targetOffset.y;

        preHandleOpacity && (ctx.globalAlpha *= opacity);

        // 解析 transformOrigin
        const origins = origin.split(' ');
        const originX = origins[0];
        const originY = origins.length > 1 ? origins[1] : origins[0];

        // 计算动态中心点
        const getOrigin = () => {
            let ox, oy;

            // 处理 originX
            switch (originX) {
                case 'left':
                    ox = x;
                    break;
                case 'center':
                    ox = x + width / 2;
                    break;
                case 'right':
                    ox = x + width;
                    break;
                default:
                    if (!originX) {
                        ox = x + width / 2;
                    } else if (originX.indexOf('%') !== -1) {
                        ox = x + (width * parseFloat(originX)) / 100;
                    } else {
                        ox = x + parseFloat(originX);
                    }
            }

            // 处理 originY
            switch (originY) {
                case 'top':
                    oy = y;
                    break;
                case 'center':
                    oy = y + height / 2;
                    break;
                case 'bottom':
                    oy = y + height;
                    break;
                default:
                    if (!originY) {
                        oy = y + height / 2;
                    } else if (originY.indexOf('%') !== -1) {
                        oy = y + (height * parseFloat(originY)) / 100;
                    } else {
                        oy = y + parseFloat(originY);
                    }
            }

            return { ox, oy };
        };

        // 检测 perspective
        const perspectiveTransform = transforms.find(t => t.indexOf('perspective') !== -1);
        const perspective = perspectiveTransform
            ? parseFloat(perspectiveTransform.replace('perspective(', '').replace('px)', ''))
            : 0;

        // 只有非 3D 才应用 transform
        if (perspective === 0) {
            transforms.forEach(transform => {
                if (transform.indexOf('translateX') !== -1) {
                    const translateX = parseFloat(transform.replace('translateX(', ''));
                    const isPercentage = transform.indexOf('%') !== false;
                    if (isPercentage) x += (width * translateX) / 100;
                    else x += translateX;
                } else if (transform.indexOf('translateY') !== -1) {
                    const translateY = parseFloat(transform.replace('translateY(', ''));
                    const isPercentage = transform.indexOf('%') !== false;
                    if (isPercentage) y += (height * translateY) / 100;
                    else y += translateY;
                } else if (transform.indexOf('scale') !== -1) {
                    const scale = parseFloat(transform.replace('scale(', ''));
                    const { ox, oy } = getOrigin();
                    ctx.translate(ox, oy);
                    ctx.scale(scale, scale);
                    ctx.translate(-ox, -oy);
                } else if (transform.indexOf('rotateX') !== -1) {
                    const degree = parseFloat(transform.replace('rotateX(', ''));
                    const angleInRadians = (degree * Math.PI) / 180;

                    const { ox, oy } = getOrigin();
                    ctx.translate(ox, oy);
                    // 创建3D旋转矩阵
                    const cosAngle = Math.cos(angleInRadians);
                    const sinAngle = Math.sin(angleInRadians);
                    const rotateMatrix = [
                        [1, 0, 0],
                        [0, cosAngle, -sinAngle],
                        [0, sinAngle, cosAngle],
                    ];
                    // 将3D旋转矩阵应用于Canvas的transform
                    ctx.transform(rotateMatrix[0][0], rotateMatrix[1][0], rotateMatrix[0][1], rotateMatrix[1][1], 0, 0);
                    ctx.translate(-ox, -oy);
                } else if (transform.indexOf('rotateY') !== -1) {
                    const degree = parseFloat(transform.replace('rotateY(', ''));
                    const angleInRadians = (degree * Math.PI) / 180;

                    const { ox, oy } = getOrigin();
                    ctx.translate(ox, oy);
                    // 创建3D旋转矩阵
                    const cosAngle = Math.cos(angleInRadians);
                    const sinAngle = Math.sin(angleInRadians);
                    const rotateMatrix = [
                        [cosAngle, 0, sinAngle],
                        [0, 1, 0],
                        [-sinAngle, 0, cosAngle],
                    ];

                    // 将3D旋转矩阵应用于Canvas的transform
                    ctx.transform(rotateMatrix[0][0], rotateMatrix[1][0], rotateMatrix[0][1], rotateMatrix[1][1], 0, 0);
                    ctx.translate(-ox, -oy);
                } else if (transform.indexOf('rotate') !== -1) {
                    const degree = parseFloat(transform.replace('rotate(', ''));
                    const angleInRadians = (degree * Math.PI) / 180;
                    const { ox, oy } = getOrigin();

                    ctx.translate(ox, oy);
                    ctx.rotate(angleInRadians);
                    ctx.translate(-ox, -oy);
                }
            });
        }

        const clipPath = animeStyle['clip-path'];

        return {
            px: x,
            py: y,
            opacity,
            clipPath,
            is3DMotion: perspective !== 0,
            Motion3DData: { transforms, perspective },
            targetOffset,
        };
    }

    /**
     * @description 绘制到统一的一个画布上
     * @param target
     * @param size
     * @param options
     * @param {number} options.offsetTime
     */
    // 绘制到统一的一个画布上
    drawToCanvas(mainCanvasCtx, viewSize, options = {}) {
        if (!mainCanvasCtx) return;
        // groupViewSize 实际画布尺寸，在打组元素的子元素中 viewSize为组的尺寸
        const { offsetTime, groupExpandSize = { horizontal: 0, vertical: 0 } } = options;

        let elementCanvas = this.getElementCanvas(viewSize, options);
        const elementStyleData = this.getElementStyleData();
        if (!elementStyleData || !elementCanvas) return;

        const { elementContainerStyle, animeContainerStyle, customAnimationContainerStyle } = elementStyleData;
        const { width, height } = this._getContainerSize(viewSize);
        const expandSize = this.getExpandSize(viewSize, offsetTime);
        const preHandleOpacity = false;

        let currentCtx = mainCanvasCtx;

        let tempCanvas = null;
        if (!preHandleOpacity) {
            tempCanvas = FJPoolStore.getCanvas();
            tempCanvas.width = mainCanvasCtx.canvas.width;
            tempCanvas.height = mainCanvasCtx.canvas.height;
            const tempCtx = tempCanvas.getContext('2d');

            currentCtx = tempCtx;
        }

        // 运动追踪数据处理
        let translateX = 0;
        let translateY = 0;
        try {
            const translate = customAnimationContainerStyle
                ? customAnimationContainerStyle.transform.replace('translate(', '')
                : '';
            const translates = translate.split(',');
            translateX = parseFloat(translates[0]) || 0;
            translateY = translates.length > 1 ? parseFloat(translates[1]) : translateX;
        } catch (e) {}

        currentCtx.save();

        // 混合模式
        const blendMode = elementContainerStyle?.mixBlendMode;
        if (blendMode && blendMode !== 'normal') {
            currentCtx.globalCompositeOperation = blendMode;
        }

        // 应用容器层样式
        const containerData = this._applyContainerStyleToContext(elementContainerStyle, currentCtx, {
            px: 0,
            py: 0,
            width,
            height,
            preHandleOpacity,
            groupExpandSize,
        });

        // 应用动画层样式
        let finalPx = containerData.px - expandSize.horizontal + groupExpandSize.horizontal + translateX;
        let finalPy = containerData.py - expandSize.vertical + groupExpandSize.vertical + translateY;

        const canvasWidth = width + expandSize.horizontal * 2;
        const canvasHeight = height + expandSize.vertical * 2;

        if (animeContainerStyle) {
            const animeData = this._applyAnimationStyleToContext(animeContainerStyle, currentCtx, {
                ...containerData,
                width: canvasWidth,
                height: canvasHeight,
                px: finalPx,
                py: finalPy,
                preHandleOpacity,
            });

            finalPx = animeData.px;
            finalPy = animeData.py;

            if (animeData.clipPath) {
                elementCanvas = FJDomCanvasRender.clipCanvas(elementCanvas, animeData.clipPath, {
                    expandWidth: expandSize.horizontal,
                    expandHeight: expandSize.vertical,
                });
            }

            // 处理 3D perspective
            if (animeData.is3DMotion && animeData.Motion3DData.perspective) {
                FJCssPerspectiveToWebGLManager.convertCssPerspectiveToWebGL({
                    canvas: elementCanvas,
                    transforms: animeData.Motion3DData.transforms,
                    perspective: animeData.Motion3DData.perspective,
                    isRebindTexture: true,
                    id: this._id,
                    usePublic: true,
                });
            }
        }

        currentCtx.drawImage(elementCanvas, finalPx, finalPy, elementCanvas.width, elementCanvas.height);
        currentCtx.restore();

        if (!preHandleOpacity) {
            mainCanvasCtx.drawImage(tempCanvas, 0, 0, tempCanvas.width, tempCanvas.height);
            FJPoolStore.releaseCanvas(tempCanvas);
        }
    }

    /**
     * @description 获取元素的扩展大小
     * @returns {Object}
     */
    getExpandSize(viewSize, time) {
        if (this._shouldApply3DAnimationExpand(time)) {
            const expandSize = this._calculate3DAnimationExpandSize(elementCanvasRect);
            return {
                horizontal: expandSize.horizontal,
                vertical: expandSize.vertical,
            };
        }

        return {
            horizontal: 0,
            vertical: 0,
        };
    }

    /**
     * @description 获取元素的渲染样式数据 位置信息，以及旋转等等
     * @returns {Object}
     */
    getElementStyleData() {
        const animeTag = this._animationTarget && this._animationTarget();
        const content = this._animationTargetContainer();
        const customAnimationTarget = this.getCustomAnimationTarget();

        const elementContainerStyle = content?.style;
        const animeContainerStyle = animeTag?.style;
        const customAnimationContainerStyle = customAnimationTarget?.style;

        return {
            elementContainerStyle,
            animeContainerStyle,
            customAnimationContainerStyle,
        };
    }

    set applyToWebGLEffect(value) {
        this._applyToWebGLEffect = value;
    }

    get applyToWebGLEffect() {
        return this._applyToWebGLEffect;
    }
}

export default FJSprite;
